
import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import { ThemeProvider } from "./components/theme/theme-provider";
import Index from "./pages/Index";
import About from "./pages/About";
import NotFound from "./pages/NotFound";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import Browse from "./pages/Browse";
import Dashboard from "./pages/Dashboard";
import Settings from "./pages/Settings";
import TermsOfUse from "./pages/TermsOfUse";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import CreateAgent from "./pages/CreateAgent";
import AgentProfile from "./pages/AgentProfile";
import AgentRuntime from "./pages/AgentRuntime";
import MyAgents from "./pages/MyAgents";
import Categories from "./pages/Categories";
import CategoryView from "./pages/CategoryView";
import Insights from "./pages/Insights";
import AgentStatus from "./pages/AgentStatus";
import AIConnections from "./pages/AIConnections";
import Profile from "./pages/Profile";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import EmailConfirmation from "./pages/EmailConfirmation";
import ChangePassword from "./pages/ChangePassword";
import AuthCallback from "./pages/AuthCallback";
import { AdminRoute } from "./routes/AdminRoute";
import { Toaster } from "@/components/ui/toaster";
import { ToastAction } from "@/components/ui/toast";
import { toast } from "@/components/ui/use-toast";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

function App() {
  useEffect(() => {
    // Example of how to show a toast notification
    toast({
      title: "Welcome to OGMAI",
      description: "The AI agent marketplace - explore, create, and share.",
      action: <ToastAction altText="Browse">Browse</ToastAction>,
    });
  }, []);

  return (
    <ThemeProvider defaultTheme="light" storageKey="ogmai-theme">
      <BrowserRouter>
        <div className="flex flex-col min-h-screen w-full">
          <Navbar />
          <main className="flex-1 w-full">
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/about" element={<About />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/browse" element={<Browse />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/terms" element={<TermsOfUse />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/create-agent" element={<CreateAgent />} />
              <Route path="/agent/:id" element={<AgentProfile />} />
              <Route path="/runtime/:id" element={<AgentRuntime />} />
              <Route path="/my-agents" element={<MyAgents />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/category/:slug" element={<CategoryView />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/agent-status/:id" element={<AgentStatus />} />
              <Route path="/ai-connections" element={<AIConnections />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/email-confirmation" element={<EmailConfirmation />} />
              <Route path="/change-password" element={<ChangePassword />} />
              <Route path="/auth/callback" element={<AuthCallback />} />

              {/* Admin Routes */}
              <Route path="/admin/*" element={<AdminRoute />} />

              {/* Not found route */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
      <Toaster />
    </ThemeProvider>
  );
}

export default App;
